import { NgModule } from '@angular/core';
import { SharedModule } from '@core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/services/auth/auth.guard';

const routes = [
        {
            path        : 'propiedades',
            loadChildren: './ownership/ownership.module#OwnershipModule',
            canActivate: [AuthGuard],

        },
        {
            path        : 'perfil',
            loadChildren: './profile/profile.module#ProfileModule',
            canActivate: [AuthGuard]
        }
];
@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
    ]
})
export class AdminModule {
}
